/**
 * Centralized English-only currency formatting
 * Format: CODE amount (e.g., "AED 10,000.00" or "USD 2,500.00")
 * Uses explicit 'en-US' locale to prevent any localization
 */

// Currency definitions (English only)
export const CURRENCIES = [
  { code: 'AED', name: 'UAE Dirham', symbol: 'AED' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'SAR', name: 'Saudi Riyal', symbol: 'SAR' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
  { code: 'QAR', name: 'Qatari Riyal', symbol: 'QAR' },
  { code: 'OMR', name: 'Omani Rial', symbol: 'OMR' },
  { code: 'BHD', name: 'Bahraini Dinar', symbol: 'BHD' },
  { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'KWD' },
];

// Default currency state — updated by Settings page
let _currencyCode = 'USD';
let _currencySymbol = '$';

export function setCurrency(code, symbol) {
  _currencyCode = code || 'USD';
  _currencySymbol = symbol || '$';
}

export function getCurrencyCode() {
  return _currencyCode;
}

export function getCurrencySymbol() {
  return _currencySymbol;
}

/**
 * Format a number as currency: "USD 10,000.00"
 * Always uses en-US locale for consistent English number formatting
 */
export function fmtCurrency(amount, decimals = 2) {
  const n = Number(amount) || 0;
  const formatted = Math.abs(n).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  const prefix = n < 0 ? '-' : '';
  return `${prefix}${_currencySymbol} ${formatted}`;
}

/**
 * Format with sign: "+USD 5,000" or "-USD 1,200"
 */
export function fmtCurrencySigned(amount, decimals = 2) {
  const n = Number(amount) || 0;
  const formatted = Math.abs(n).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  const sign = n >= 0 ? '+' : '-';
  return `${sign}${_currencySymbol} ${formatted}`;
}

/**
 * Short format (no decimals): "USD 10,000"
 */
export function fmtCurrencyShort(amount) {
  return fmtCurrency(amount, 0);
}
